import { TERMS_OF_SERVICE_DOCUMENT } from "@-/dev.improve.haniverse.lib.legal";
import { LegalDocumentPage } from "#legal-document-page";

/** The public Terms of Service at `/terms`, rendered on web only. */
export function TermsOfServicePage() {
  return (
    <LegalDocumentPage
      description="The terms that govern your access to and use of Haniverse."
      document={TERMS_OF_SERVICE_DOCUMENT}
    />
  );
}
